import { render } from "./controlIcons.vue?vue&type=template&id=0477dc3f&scoped=true"
import script from "./controlIcons.vue?vue&type=script&lang=js"
export * from "./controlIcons.vue?vue&type=script&lang=js"

import "./controlIcons.vue?vue&type=style&index=0&id=0477dc3f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0477dc3f"]])

export default __exports__